import { gridSizeMdLg12, } from '@/shared/constants/ui.constants';
import { formatDateWithTimeAMPM } from '@/shared/utils/format-date';
import CloseIcon from '@mui/icons-material/Close';
import DraftsIcon from '@mui/icons-material/Drafts';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {
  Badge,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  SvgIcon,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import './MenuNotification.css';
import { useFetchPutNotificacion } from '@/shared/actions/erp/notificacion.actions';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LineAxisIcon from '@mui/icons-material/LineAxis';
import RouteIcon from '@mui/icons-material/Route';
import SettingsIcon from '@mui/icons-material/Settings';
import { NotificacionDataRes } from '@/shared/interfaces/erp/system-settings/notificacion.interface';

interface MenuNotificationProps {
  isLoadingNotificacion: boolean;
  dataNotificacion: NotificacionDataRes | undefined;

  setPage: React.Dispatch<React.SetStateAction<number>>;
  page: number;

  maxPage: number;
  setMaxPage: React.Dispatch<React.SetStateAction<number>>;

}
const MenuNotification = ({ isLoadingNotificacion,
  dataNotificacion,

  setPage,
  page,

  maxPage,
  setMaxPage
}: MenuNotificationProps) => {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);

    if (!isLoadingNotificacion) {
      setMaxPage(dataNotificacion?.numero_paginas ?? 1);
    }
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const fetchPutNotificacion = useFetchPutNotificacion();


  const handleClickSelect = () => {

  }

  useEffect(() => {

  }, [isLoadingNotificacion])


  function iconoNotification(key: string) {
    switch (key) {
      case 'prospectos':
        return <LineAxisIcon color={'info'} fontSize="medium" />;
      case 'preventas':
        return <RouteIcon color={'warning'} fontSize="medium" />;
      case 'sistema':
        return <SettingsIcon color='inherit' />
      default:
        return <NotificationsNoneIcon color={'primary'} fontSize="medium" />;
    }
  }


  return (
    <>
      <Tooltip title="Notificaciones">
        <IconButton onClick={handleClick}>
          <Badge badgeContent={dataNotificacion?.count} color="success" >
            <SvgIcon sx={{ fontSize: '30px' }}>
              <NotificationsIcon />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        keepMounted
        onClose={handleClose}
        //onClick={handleClose}
        className="transparent-gray-background"
      >
        {/*sx={{ maxWidth: '500px', width: '400px', margin: '0px 5px' }}>*/}
        <Box className='box-notificacion' >

          <Grid container justifyContent={'space-between'} style={{ padding: '8px 10px' }}>
            <Grid item>
              <div style={{ display: 'flex' }}>
                <DraftsIcon color='primary' />
                <Typography style={{ marginLeft: '15px' }} variant="subtitle1">Notificaciones</Typography>
              </div>
            </Grid>

            <Grid item>
              <Grid container justifyContent={'end'}>
                <Grid item>
                  <IconButton disabled={page == 1} onClick={async () => {
                    setPage(e => e - 1);
                  }}>
                    <KeyboardArrowLeftIcon />
                  </IconButton>
                </Grid>
                <Grid item>
                  <IconButton disabled={page == maxPage} onClick={async () => {
                    setPage(e => e + 1);
                  }}>
                    <KeyboardArrowRightIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
          {
            isLoadingNotificacion ? <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', height: '300px' }} >
              <CircularProgress color="inherit" /></div> :
              (
                <>
                  {dataNotificacion?.data.length == 0 && <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', height: '300px' }}>Sin Notificaciones</div>}

                  {dataNotificacion?.data.map((value) => (
                    <Grid container style={{ padding: '8px 10px', }} key={value.codigo} >

                      <Grid item container {...gridSizeMdLg12} justifyContent={'space-between'} justifyItems={'center'} onClick={handleClickSelect} style={{ cursor: 'pointer' }}>
                        <Grid item style={{ display: 'flex' }}>
                          {iconoNotification(value.modulo)}
                          <Typography style={{ marginLeft: '15px' }} variant="body1" fontWeight={'bold'}>{value.modulo.toUpperCase()}</Typography>
                        </Grid>

                      </Grid>

                      <Grid item container {...gridSizeMdLg12} style={{ padding: '10px 0px' }} justifyContent={'space-between'}>
                        <Grid item xs={11} onClick={handleClickSelect} style={{ cursor: 'pointer' }}>
                          <Typography variant="body1" >{value.mensaje}</Typography>
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={async () => {
                            await fetchPutNotificacion.mutateAsync({ idNotificacion: value.id_notificacion, data: { visto: true } });
                            if (dataNotificacion.data.length === 1) {
                              setPage(1)
                              setMaxPage(1);
                            }
                          }}>
                            <CloseIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      <Grid item onClick={handleClickSelect} style={{ cursor: 'pointer' }}>
                        <Typography variant="subtitle2" fontSize={'10px'}>{formatDateWithTimeAMPM(value.fecha_creacion)}</Typography>
                      </Grid>

                    </Grid>
                  ))
                  }
                </>
              )
          }

        </Box>
      </Menu>
    </>
  );
};

export default MenuNotification;